export default class LuxLeadUpdate {
  #lead;
  #triggerValue;
  #value;
  #fingerPrint;

  constructor(lead, triggerValue = 0) {
    this.#lead = lead;
    this.#triggerValue = triggerValue;
    this.#value = 0;
    this.#getUserFingerPrint();
  }

  getValue() {
    return this.#value;
  }

  setValue(value) {
    this.#value = value;
    this.#checkTriggerUpdate();
  }

  getTriggerValue() {
    return this.#triggerValue;
  }

  increaseValue(number = 10) {
    this.#value += number;
    this.#checkTriggerUpdate();
  }

  decreaseValue(number = 10) {
    this.#value -= number;
  }

  updateTriggerValue(value) {
    this.#triggerValue = value;
    this.#checkTriggerUpdate();
  }

  #checkTriggerUpdate() {
    if (this.#value >= this.#triggerValue) {
      this.#updateLeadValue();
    }
  }

  #updateLeadValue() {
    const host = window.location.host;
    const path = "luxenterprise_api.json";
    const encodedBody = `tx_luxenterprise_api[arguments]=${encodeURIComponent(
      this.#getUpdateLeadBody()
    )}`;
    const encodedBody2 = `tx_luxenterprise_api[arguments]=${this.#getUpdateLeadBody()}`;
    fetch(`https://${host}/${path}`, {
      method: "POST",
      headers: {
        "Api-Key":
          "rWS6u03e6nyT3YOnRcstOXGf4D19cql3tRZKuXG4WWzpG6O0Bx8UXazV55E4WMFMxNABUPJAimjLTBiuiIR4wnEaT2j1VJKRpmM4y5xqRsMyYLgBT8fYGF51aYd1dZDx",
      },
      body: encodedBody,
    })
      .then((response) => {
        if (response.ok) {
        }
      })
      .catch((error) => {
      });
  }

  #getUserFingerPrint() {
    const lux = LuxSingleton.getInstance();
    if (lux.getIdentification().isIdentificatorSet()) {
      const identificator = lux.getIdentification().getIdentificator();
      this.#fingerPrint = identificator;
    }
  }

  #getUpdateLeadBody() {
    const body = {
      endpoint: "create",
      merge: {
        mergeByEmail: 0,
        mergeByFingerprint: 1,
      },
      properties: {
        visitor: {
          attributes: {
            0: {
              name: this.#lead,
              value: this.#value,
            },
          },
          fingerprints: {
            0: {
              value: this.#fingerPrint,
            },
          },
        },
      },
    };
    return JSON.stringify(body);
  }
}
